import React, { useState } from "react";
import LoanCard from "../../../../components/card/LoanCard";
import {
  filterLoanStatus,
  filterVisibleLoans,
  getUniqueLoanStatuses,
  showLoanStatusMessage,
} from "../../../../utils/loan";
import styles from "./style.module.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLoanStore } from "../../../../stores/useLoanStore";

const CurrentLoans = ({ loans }) => {
  const [filter, setFilter] = useState({ loanStatus: "" });

  const navigate = useNavigate();

  const visibleLoans = filterVisibleLoans(loans);

  const loanStatuses = getUniqueLoanStatuses(visibleLoans);

  const filteredLoans = filterLoanStatus(visibleLoans, filter.loanStatus);
  
  const { t, i18n } = useTranslation('myLoan');
  const activeLoanStatuses = [
  "request",
  "open",
  "document_reject",
  "disburse_process",
  "disburse",
  "accept",
  "approve",
  "change_principle",
  "score_confirm",
  "document_confirm",
  "default"
];
  const setIncomeFormProfile = useLoanStore((state) => state.setIncomeFormProfile);

  function handleNavigateToRenewLoan() {
    setIncomeFormProfile({ monthly_income: 50000, out_time_income: "", other_income: "", is_mou: false });
    navigate("/select-loan");
  }

  return (
    <div className={styles.container}>
      {loans?.length > 0 && (
        <select onChange={(e) => setFilter({ loanStatus: e.target.value })}>
          <option value="">{t('selectStatus')}</option>
          {activeLoanStatuses.map((status) => (
            <option key={status} value={status}>
              {t(status)}
            </option>
          ))}
        </select>
      )}
      {filteredLoans?.length > 0 ? (
        <div className={styles.loanList}>
          {filteredLoans.map((loan) => (
            <LoanCard loan={loan} />
          ))}
        </div>
      ) : (
        <section className={styles.notFound}>
          <h1>{t('doNotFoundCurrent')}</h1>
          <button
            className={styles.applyButton}
            onClick={handleNavigateToRenewLoan}
          >
            {t('Register')}
          </button>
        </section>
      )}
    </div>
  );
};

export default CurrentLoans;
